<template>
    <div>
        <template v-if="currentUser.isAdmin">
            <div class="row d-flex align-items-center mt-5">
                <div class="col-sm-2">
                    <h4>Menedžeri</h4>
                </div>
                <div class="col-sm-5 d-flex justify-content-end">
                    <UsersAdd/>
                </div>
            </div>
            <SkeletonLoader v-if="isLoading" :skeleton-data="skeletonData"/>
            <UsersList :user-role="'manager'" v-else/>
        </template>

        <div class="row d-flex align-items-center mt-5">
            <div class="col-sm-2">
                <h4>Darbinieki</h4>
            </div>
            <div class="col-sm-7 d-flex justify-content-end">
                <UsersAdd/>
                <UsersImport/>
                <UsersExport/>
            </div>
            <div class="col-sm-3">
                <div class="text-center">
                    <input type="text" v-model="searchTerm" placeholder="Meklēt darbiniekus..."
                           class="my-4 px-4 py-2 ds-input" @input="attemptSearch">
                </div>
            </div>
        </div>
        <SkeletonLoader v-if="isLoading" :skeleton-data="skeletonData"/>
        <UsersList :user-role="'user'" v-else/>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import UsersList from '@/components/users/UsersList';
    import UsersAdd from '@/components/users/UsersAdd';
    import UsersImport from '@/components/users/UsersImport';
    import UsersExport from '@/components/users/UsersExport';
    import * as userStoreTypes from '../../vuex/modules/user/user.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import * as authStoreTypes from '../../vuex/modules/auth/auth.store-types';
    import {SkeletonLoaderRepository} from '../global/skeleton-loader/SkeletonLoaderRepository';
    import SkeletonLoader from '@/components/global/skeleton-loader/SkeletonLoader';

    export default {
        name: 'users',
        components: {UsersImport, UsersExport, UsersList, UsersAdd, SkeletonLoader},
        data: () => ({searchTerm: '', skeletonData: SkeletonLoaderRepository.usersListLayout}),
        computed: {
            ...mapGetters('user', {
                /** @type {Company|*} */
                isLoading: userStoreTypes.GET_IS_LOADING,
            }),
            ...mapGetters('auth', {
                /** @type {CurrentUser|*} */
                currentUser: authStoreTypes.GET_CURRENT_USER,
            }),
        },
        methods: {
            ...mapMutations('company', {
                /** @type {function|*} */
                setCurrentCompanyUsers: companyStoreTypes.SET_CURRENT_COMPANY_USERS,
            }),
            ...mapActions('user', {
                /** @type {function|*} */
                getUsers: userStoreTypes.ACTION_GET_USERS,
            }),
            /**
             * Search company by name with 500ms delay.
             */
            attemptSearch() {
                clearTimeout(this.searchTimeout);
                if (this.searchTerm.length < 3 && this.searchTerm.length > 0) return
                this.searchTimeout = setTimeout(async () => {
                    const users = await this.getUsers({companyId: this.$route.params.companyId || this.currentUser.company._id, name: this.searchTerm});
                    this.setCurrentCompanyUsers(users);
                }, 500);
            },
        }
    }
</script>
